<div class="top-row" *ngIf="mobileView">
  <span class="back-btn" (click)="closeDatePopover()">
    <i class="fa fa-arrow-left"></i>
    Guests & Rooms
  </span>
</div>

<div class="room-wrapper">
  <div class="rooms" *ngFor="let room of rooms; let index = index">
   <div class="d-flex flex-row justify-content-start align-items-start gap-0  " >
    <span class="lbl-room">Room {{index + 1}}</span>
    <span class="dlt-btn-margin" *ngIf="rooms.length > 1 && index > 0" >  <img  src='https://s3.ap-south-1.amazonaws.com/zentrumhub.email.assets/JoyLife/delete.png' [ngClass]="{'disabled': !enableRemoveRoomBtn}" (click)="removeRoom()"></span>
   </div>
    <!--{{room.label}}-->
    <div class="room" *ngFor="let pt of passangerTypes">
      <div class="passanger-count">
        <div class="passangers">
          <!-- {{type.count}}-->
          {{getCount(pt.type, room)}}
        </div>
        <div class="passanger-label">{{pt.type}}</div>
        <div class="passanger-subtitle">{{pt.subtitle}}</div>
        <div class="passanger-counter">
          <!--  <travel-ui-counter [config]="{minValue: pt.minValue, value: pt.count}" (numberChange)="handleChange($event, type)"></travel-ui-counter>-->
          <travel-ui-counter [value]="getCount(pt.type, room)" [maxValue]="pt.maxValue" [minValue]="pt.minValue"
            (numberChange)="handleChange($event, pt, room)"></travel-ui-counter>
        </div>
      </div>
      <div class="children-ages" *ngIf="pt.type === 'Children' && room.children">
        <label>Age of Children: </label>
        <div class="child-wrapper">
          <div *ngFor="let child of room.childAges; let i=index;">
            <select class="child-age" [value]="room.childAges[i]" (change)="onChange($event, i, room)">
              <option value="0">Under 1</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
              <option value="13">13</option>
              <option value="14">14</option>
              <option value="15">15</option>
              <option value="16">16</option>
              <option value="17">17</option>             
            </select>
          </div>
        </div>

        <!--<select class="child-age" [(ngModel)]="type.ageArray[i]" *ngFor="let child of type.ageArray; let i=index;">
          <option>
            <1</option> <option>2
          </option>
          <option>3</option>
          <option>4</option>
          <option>5</option>
          <option>6</option>
          <option>7</option>
          <option>8</option>
          <option>9</option>
          <option>10</option>
          <option>11</option>
          <option>12</option>
        </select>-->
      </div>
    </div>
  </div>
  <div class="btn-action-room">
    <button (click)="addRoom()" [ngClass]="{
      'disabled': disableAddRoomBtn,
      'joy-button': appContext.siteName == 'Joy' ? true : appContext.siteName == 'DemoPortal',
      'button': appContext.siteName != 'Joy' ? (appContext.siteName != 'DemoPortal') : false
    }">Add Room</button>
    <!-- <button [ngClass]="{'disabled': !enableRemoveRoomBtn}" (click)="removeRoom()">Remove Room</button> -->
  </div>
  <div class="done">
    <button (click)="doneChanges();"  [ngClass]="
    appContext.siteName == 'Joy' ? 'joy-button' : appContext.siteName == 'DemoPortal' ? 'joy-button' : 'button'
  ">Done</button>
  </div>
</div>